import React from "react";

import { Button, Modal } from "react-bootstrap";

export const CloneModal = ({ modalInfo, setModalInfo}) => {
    const closeModal = () => {
        setModalInfo({
            ...modalInfo,
            open: false,
        });
    };

    return (
        <Modal
            show={modalInfo.open}
            onHide={() => closeModal()}
            size="sm"
            centered
        >
            <Modal.Body className="text-center m-3">
                <p className="mb-0">{modalInfo.notifMsg}</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => closeModal()}>
                    Close
                </Button>{" "}
                <Button variant={modalInfo.severity} onClick={() => closeModal()} href={`/tms/quotations/clone/${modalInfo.id}`} target="_blank" rel="noreferrer">
                    Confirm
                </Button> 
            </Modal.Footer>
        </Modal>
    );
};
